<template>
  <ul
    v-if="list"
    class="product-tab-list"
  >
    <slot name="before" />
    <li
      v-for="(entry, index) in list"
      :key="index"
      class="product-tab-list__entry"
    >
      <div class="product-tab-list__label">
        {{ entry.name }}
      </div>
      <div
        class="product-tab-list__value unstyled-html"
        v-html="replaceFootnotes(entry.value)"
      />
    </li>
    <slot name="after" />
  </ul>
</template>

<script setup lang="ts">
import { replaceFootnotes } from '@i22team/rocket';

export type ProductTabListType = { name: string; value: string };

export type ProductTabListProps = {
  list?: ProductTabListType[];
};

withDefaults(defineProps<ProductTabListProps>(), {
  list: undefined,
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.product-tab-list {
  @include mq($mq-sm) {
    column-gap: $grid-base * 2;
    columns: 2;
  }

  @include mq($mq-md) {
    columns: 3;
  }

  &__label {
    font-weight: 700;
  }

  &__entry {
    list-style: none;
    padding-bottom: 12px;
    @include mq($mq-sm) {
      break-inside: avoid-column;
      page-break-inside: avoid;
      -webkit-column-break-inside: avoid;
    }
  }
}
</style>
